<template>
  <LoadingSpinner :loading="loading"> </LoadingSpinner>

  <div :class="panelMode ? 'p-3' :'container mt-4 mb-4'">
    <div class="mt-2" style="max-width:597px">
        <div class="text-muted">Tilbehørsbibliotek</div>
        <h3 style="padding-right: 60px">Legg til</h3>

        <div class="mt-4">
          <span class="ingredient-title">Koble til produkt fra menyen (valgfritt)</span>
          <ItemPicker v-model="addOnTemplate.itemId" :items="items" :categories="categories" @change="onItemSelected"/>
          <div v-if="addOnTemplate.itemId" class="text-muted mt-1">
            Navn og pris hentes fra produktet, og holdes synkronisert. Når produktet er utsolgt, vises valget som utsolgt.
          </div>
        </div>

        <div class="mt-4">
          <span class="ingredient-title">Navn</span>
          <input class="form-control" type="text" v-model="addOnTemplate.name" :disabled="isLinkedToItem"/>
        </div>

        <div class="mt-4">
          <span class="ingredient-title">Pris ta med/takeaway</span>
        </div>
        <div class="row">
            <div class="col-sm-6">
              <input class="form-control" type="number" min="0" v-model="price" @input="updatePriceWithVat()" :disabled="isLinkedToItem"/>
              <div class="text-muted">(uten MVA)</div>
            </div>
            <div class="col-sm-6">
              <input class="form-control" type="number" min="0" v-model="priceWithVat" @input="updatePrice()" :disabled="isLinkedToItem"/>
              <div class="text-muted">(med MVA, {{ vat.takeOut }}%)</div>
            </div>
        </div>
        <div v-if="useFunctionality === 'POS' || useFunctionality === 'KIOSK_TAKEAWAY' || useFunctionality === 'ALL'">
          <div class="mt-3">
            <span class="ingredient-title">Pris spise her</span>
          </div>
          <div class="row">
            <div class="col-sm-6">
              <input class="form-control" type="number" min="0" v-model="priceDineIn" @input="updatePriceDineInWithVat()" :disabled="isLinkedToItem"/>
              <div class="text-muted">(uten MVA)</div>
            </div>
            <div class="col-sm-6">
                <input class="form-control" type="number" min="0" v-model="priceDineInWithVat" @input="updatePriceDineIn()" :disabled="isLinkedToItem"/>
                <div class="text-muted">(med MVA, {{ vat.dineIn }}%)</div>
            </div>
          </div>
          <div v-if="dineInPriceSuggestion" class="mt-1">
            <a href="#" class="bo_suggestion-btn" @click.prevent="applyDineInPriceSuggestion">
              Klikk for å bruke samme grunnpris som ta med: kr {{ dineInPriceSuggestion }} uten mva = kr {{ dineInPriceSuggestionWithVat }} med {{ vat.dineIn }}% mva
            </a>
          </div>
        </div>

        <div class="bo_hr mt-4">
          <hr/>
        </div>

        <div class="mb-5">
          <button v-if="activateSaveButton" type="button" class="bo_btn" @click="saveAddOnTemplate"> Lagre </button>
          <button v-else type="button" class="bo_btn" @click="saveAddOnTemplate" disabled="true"> Lagre </button>
        </div>
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "@/components/other/LoadingSpinner";
import ItemPicker from "@/components/product/ItemPicker";
import MerchantUtil from "@/util/MerchantUtil";
import ProductService from "@/services/product/ProductService";
import ItemUtil from "@/util/ItemUtil";

export default {
  components: {LoadingSpinner, ItemPicker},
  props: {
    panelMode: { type: Boolean, default: false },
    vat: { type: Object, default: () => ({}) },
    //Data already loaded by the products page, makes the panel open without any requests
    itemsProp: { type: Array, default: null },
    categoriesProp: { type: Array, default: null }
  },
  emits: ['saved'],
  data() {
    return {
      loading: true,

      items: [],
      categories: [],

      price: 0,               //Takeaway price without VAT
      priceWithVat: "",       //Takeaway price with VAT
      priceDineIn: 0,         //Dine-in price without VAT
      priceDineInWithVat: "", //Dine-in price with VAT

      addOnTemplate: {
        type: "add-on_template",
        merchant: "",
        name: "",
        price: 0,
        priceDineIn: 0,
        itemId: ""
      }
    };
  },
  mounted() {
    this.addOnTemplate.merchant = MerchantUtil.getMerchant();

    if(this.itemsProp && this.categoriesProp){
      //Data already loaded by the products page, no requests needed
      this.items = this.itemsProp;
      this.categories = this.categoriesProp;
      this.loading = false;
      return;
    }

    Promise.all([
      ProductService.getItems(),
      ProductService.getCategories()
    ]).then(
        ([itemsResponse, categoriesResponse]) => {
          this.items = itemsResponse.data;
          this.categories = categoriesResponse.data;
          this.loading = false;
        },
        (error) => {
          console.log(error);
        }
    );
  },
  computed: {
    useFunctionality(){
      return MerchantUtil.useFunctionality();
    },
    activateSaveButton(){
      if(this.addOnTemplate.name.length > 0){
        return true;
      } else {
        return false;
      }
    },
    isLinkedToItem(){
      return this.addOnTemplate.itemId.length > 0;
    },
    dineInPriceSuggestion(){
      //Suggest the same base price as takeaway, the gross price differs because of the VAT difference
      if(this.isLinkedToItem || this.price === "" || Number(this.price) <= 0){
        return null;
      }
      if(Number(this.price) === Number(this.priceDineIn)){
        return null; //Already the same base price
      }
      return Number(this.price);
    },
    dineInPriceSuggestionWithVat(){
      return ItemUtil.getPriceDineIn(this.dineInPriceSuggestion || 0, this.vat);
    }
  },
  methods: {
    onItemSelected(){
      if(this.isLinkedToItem){
        let item = this.items.find(item => item.id === this.addOnTemplate.itemId);
        if(item){
          this.addOnTemplate.name = item.name;
          this.price = item.price;
          this.priceDineIn = item.priceDineIn;
          this.updatePriceWithVat();
          this.updatePriceDineInWithVat();
        }
      }
    },
    updatePriceWithVat(){
      let priceWithVat = this.price + (this.price / 100 * this.vat.takeOut);
      this.priceWithVat = Math.round(priceWithVat);
    },
    updatePriceDineInWithVat(){
      let priceDineInWithVat = this.priceDineIn + (this.priceDineIn / 100 * this.vat.dineIn);
      this.priceDineInWithVat = Math.round(priceDineInWithVat);
    },
    updatePrice(){
      this.price = ItemUtil.getPriceWithoutVat(this.vat.takeOut, this.priceWithVat);
    },
    updatePriceDineIn(){
      this.priceDineIn = ItemUtil.getPriceWithoutVat(this.vat.dineIn, this.priceDineInWithVat);
    },
    applyDineInPriceSuggestion(){
      this.priceDineIn = Number(this.price);
      this.updatePriceDineInWithVat();
    },
    saveAddOnTemplate(){
      this.loading = true;

      this.addOnTemplate.price = this.price;
      this.addOnTemplate.priceDineIn = this.priceDineIn;

      let addOnTemplate = Object.assign({}, this.addOnTemplate);
      if(!addOnTemplate.itemId){
        delete addOnTemplate.itemId;
      }
      console.log('addOnTemplate: ' + JSON.stringify(addOnTemplate));
      ProductService.createAddOnTemplate(addOnTemplate).then(
          (response) => {
            let documentId = response.data;
            if(documentId){
              if(this.panelMode){ this.$emit('saved'); } else { this.$router.push({ path: 'products'}); }
            } else {
              console.log("Creating addOnTemplate failed");
            }
            this.loading = false;
          },
          (error) => {
            console.log(error);
          }
      );
    }
  }
};
</script>
